<div [class.justified]="isJustified()" [class.row]="isInline()" [class.align-items-center]="isInline()">
  <div [class.text-end]="isInlineOnly()" [class.col-sm-2]="isInlineOnly()" [class.col-auto]="isInline()">
    <label [class.col-form-label]="isInline()" class="form-label fw-bold" [placement]="'bottom'" [ngClass]="tooltip !== null ? 'field-tip' : ''" [ngbTooltip]="tooltip">
      {{ name }}
    </label>
  </div>
  <div [class.col-sm-10]="isInlineOnly()" [class.col-auto]="isInline()">
    <shared-ui-inputs-checkbox-field
      [tabIndex]="tabIndex"
      [disabled]="disabled"
      [parentFormGroup]="parentFormGroup"
      [formName]="formName"
      [name]="name"
      [disabled]="disabled"
    ></shared-ui-inputs-checkbox-field>
  </div>
</div>
